import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import * as countryTimezone from 'country-timezone';
import { CountryCode } from '../../app/shared/country-code';
import { getCountryForTimezone } from 'country-timezone'
declare var $: any;
import { Location } from '@angular/common';


@Component({
  selector: 'app-edit-department',
  templateUrl: './edit-department.component.html',
  styleUrls: ['./edit-department.component.css']
})
export class EditDepartmentComponent implements OnInit {
  selectedTime: Date = new Date();
  country = CountryCode
  constructor(private departmentService: ServiceService, private route: ActivatedRoute, private router: Router, private location: Location) { }

  output: any = []; //---store get() result--------
  customerId = '';
  //getUrl='http://192.241.151.66:5000/viewCustomers';
  //putUrl='http://192.241.151.66:5000/updateCustomers';
  //deptUrl='http://192.241.151.66:5000/viewDepartments/department_dropdown'
  //empUrl='http://192.241.151.66:5000/viewEmployees';
  employee: any = [];
  Search_employee = "";
  searchEmployee: string = '';
  searchMember: string = '';
  isShownEmployee = false;
  name = ""
  checkedProduct: any = [];
  CheckArray: any = [];
  center = { lat: 24.4539, lng: 54.3773 }; // Set the latitude and longitude of UAE

  map_lat:any="";
  map_log:any="";
  markers:any=[];
  zoom = 12;
  employee_name = "";
  search_name = "";
  data = {

    department_Foreman_id: "",
    department_id: " ",
    department_Foreman_name: "",
    department_latitude: "",
    department_longitude: "",
    members: [],
    accounts_members : [],
    helper_members : [],
    industry_types : [],
    work_in_time:"",
    lunch_out_time:"",
    lunch_in_time:"",
    work_out_time:"",
    warehouse_id:"",
    warehouse_name:'',
    country_name:'',
    timezone : '',
    public_holidays: [],
    is_factory:false,
    cash_customers : [],
    weekly_working_days: [] as number[],

  }
  alert = "";
  employee_id = "";
  department: any = [];
  dept: any = [];
  members: any = [];
  emp1: any = [];
  isShown: boolean = false;
  EmailAlert = ""
  departmentId = ""
  email: any = new FormControl('', [Validators.required, Validators.email]);
  listEmployees: any[] = []; // Assuming you have the list of employees in this array
  warehouse_dropdown:any = []
  isChecked(employee: any): boolean {
    return (this.CheckArray??[]).some((item: any) => item.employee_id === employee.employee_id);
  }

  memberList(employee: any) {
    const isChecked = this.isChecked(employee);

    if (!isChecked) {
      this.CheckArray.push({
        employee_id: employee.employee_id,
        employee_name: employee.employee_name
      });
    } else {
      const index = this.CheckArray.findIndex((item: any) => item.employee_id === employee.employee_id);
      this.CheckArray.splice(index, 1);
    }

  }

  checkArrayacc : any = []

  isCheckedAcc(employee: any): boolean {
    return (this.checkArrayacc??[]).some((item: any) => item.employee_id === employee.employee_id);
  }

  accmemberList(employee: any) {
    const isChecked = this.isCheckedAcc(employee);

    if (!isChecked) {
      this.checkArrayacc.push({
        employee_id: employee.employee_id,
        employee_name: employee.employee_name
      });
    } else {
      const index = this.checkArrayacc.findIndex((item: any) => item.employee_id === employee.employee_id);
      this.checkArrayacc.splice(index, 1);
    }
    // debugger
  }

  accCancel(){
    this.checkArrayacc=[]
  }

  checkArrayhelp : any  = []

  isCheckedHelp(employee: any): boolean {
    return (this.checkArrayhelp??[]).some((item: any) => item.employee_id === employee.employee_id);
  }

  helpmemberList(employee: any) {
    const isChecked = this.isCheckedHelp(employee);

    if (!isChecked) {
      this.checkArrayhelp.push({
        employee_id: employee.employee_id,
        employee_name: employee.employee_name
      });
    } else {
      const index = this.checkArrayhelp.findIndex((item: any) => item.employee_id === employee.employee_id);
      this.checkArrayhelp.splice(index, 1);
    }
  }

  helpCancel(){
    this.checkArrayhelp=[]
  }

  checkArrayindustry : any = []

  isCheckedind(industry: any): boolean {
    // debugger
    return (this.checkArrayindustry??[]).some((item: any) => item.industry_type_id === industry._id);
  }


  estimateTime : string = ''
  AssignValueTime : string = ''
  timeError : string =''
  estimateTimevalue(value:any){
    this.estimateTime = value
  }

  arrayIndex : number = 0

  selectedTimes(){
    this.AssignValueTime = this.estimateTime
    this.checkArrayindustry[this.arrayIndex].estimated_time = this.AssignValueTime
    $('#estimate').modal('hide');
  }

  industryList(industry: any) {

    const isChecked = this.isCheckedind(industry);
    if (!isChecked) {
      $('#estimate').modal('show');
      if(this.estimateTime){
        this.AssignValueTime = this.estimateTime
      }else {
        this.AssignValueTime = ''
      }
      // debugger
      this.checkArrayindustry.push({
        industry_type_id : industry._id,
        industry_type_name : industry.name,
        estimated_time : this.AssignValueTime
      });
      this.arrayIndex = this.checkArrayindustry.length - 1
      // debugger
    } else {
      const index = this.checkArrayindustry.findIndex((item: any) => item.industry_type_id === industry._id);
      this.checkArrayindustry.splice(index, 1);
    }
    console.log(this.checkArrayindustry);

  }

  indCancel(){
    this.checkArrayindustry=[]
  }
  //--------function for shown the alert----------
  shown() {
    this.isShown = false
  }
  //for showing notifivation
  notification() {
    this.isShown = !this.isShown;
  }

  //-------------function for search--------------------
  SearchEmployee() {
    if (this.employee_name != '') {
      this.isShownEmployee = true;
    }
    this.searchEmployee = this.employee_name
    this.departmentService.SearchEmployee(this.searchEmployee).subscribe((res) => {
      this.employee = res.data

    })
  }
  // warehouse dropdown functions
  backup_warehouse_drop:any=[]
  warehousename_search = ""
  Warehouse_all(){
    this.departmentService.Warehouse_Dropdown().subscribe((res) => {
      this.warehouse_dropdown = res.data
      this.backup_warehouse_drop = this.warehouse_dropdown
    })
  }

  searchWarehouse(){
    this.warehousename_search = this.data.warehouse_name
  }

  selectedWarehouse(value:any){
    this.warehousename_search=""
    console.log(value)
    this.data.warehouse_name = value.warehouse_name
    this.data.warehouse_id = value.warehouse_id
    console.log(this.data)
  }

  searchMembers() {

    this.listEmployees =[]
    console.log(this.searchMember);
    this.searchMember = this.search_name
    console.log(this.searchMember);


    this.departmentService.SearchEmployee(this.searchMember).subscribe((res) => {
        this.listEmployees = res.data;

      });
  }

  weeKDays = [
    {
      week: 'Sunday',
      value: 1,
      checked: false
    },
    {
      week: 'Monday',
      value: 2,
      checked: false
    },
    {
      week: 'Tuesday',
      value: 3,
      checked: false
    },
    {
      week: 'Wednesday',
      value: 4,
      checked: false
    },
    {
      week: 'Thursday',
      value: 5,
      checked: false
    },
    {
      week: 'Friday',
      value: 6,
      checked: false
    },
    {
      week: 'Saturday',
      value: 7,
      checked: false
    },
  ];
  selectedWeek: any = [];
  weekSelected(value: any) {
    if (this.selectedWeek.includes(value)) {
      const index = this.selectedWeek.indexOf(value);
      if (index > -1) {
        this.selectedWeek.splice(index, 1);
      }
    } else {
      this.selectedWeek.push(value);
    }
    console.log(this.selectedWeek);
  }

  //---------function for getting searched employee id---------------
  getEmployeeId(value1: any, value2: any) {

    this.isShownEmployee = false
    //this.searchEmployee=value2
    //this.employee_id=value1
    this.employee_name = value2;
    this.data.department_Foreman_id = value1;
    this.data.department_Foreman_name = this.employee_name;

  }
  valuechange4(newValue1: any) {
    this.employee_name = newValue1
    this.Search_employee = ""
  }

  lunchInTime(newValue1: any){
    this.data.lunch_out_time =newValue1
  }

  lunchOutTime(newValue1: any){
    this.data.lunch_in_time =newValue1
  }
  workOutTime(newValue1: any){
    this.data.work_out_time =newValue1
  }
  workInTime(newValue1: any){
    this.data.work_in_time =newValue1
  }

  onMapClick(event: any) {
    const clickedLocation = event.coords || event.latLng || event.position;
    this.data.department_latitude = clickedLocation.lat();
    this.data.department_longitude = clickedLocation.lng();
  }

  FindLocation(lat:any,log:any){
    this.map_lat=lat;
    this.map_log=log;

    console.log("Find location");
    this.center = {
      lat:lat,
      lng:log
    };
   this.addMarker();
  }
  addMarker() {
    this.markers.push({
      position: {
        lat: this.center.lat,
        lng: this.center.lng,
      },
      label: {
        color: 'red',
        text: 'Department location',
      },
      title: 'Department location',
      options: { animation: google.maps.Animation.BOUNCE },
    });

  }

  public_holidays: any = [];
newHolidayDate: string = '';
selectedHolidayIndex: number | null = null;

addHoliday(date: string) {
  if (date && !this.public_holidays.includes(date)) {
    this.public_holidays.push(date);
    this.newHolidayDate = '';
  }
}

removeSelectedHoliday() {
  const select: HTMLSelectElement | null = document.querySelector('select.form-control');
  if (select && select.selectedIndex !== -1) {
    const selectedIndexes = Array.from(select.selectedOptions).map(opt => opt.index);
    // Remove from last to first to avoid index shifting
    selectedIndexes.sort((a, b) => b - a).forEach(idx => this.public_holidays.splice(idx, 1)); 
  }
}
  timezoneBool : boolean = true
  countryBool : boolean = true
  btnClick() {
    console.log(this.data);
    
    if(this.data.country_name != '' && this.data.country_name != null) {
      this.countryBool = true
    }else {
      this.countryBool = false
      return
    }
    if(this.data.timezone != '' && this.data.timezone != undefined) {
      this.timezoneBool = true
    }else {
      this.timezoneBool = false
      return
    }
    
    this.data.members = this.CheckArray
    this.data.accounts_members = this.checkArrayacc
    this.data.helper_members = this.checkArrayhelp
    this.data.industry_types = this.checkArrayindustry
    this.data.public_holidays = this.public_holidays

    this.data.weekly_working_days = this.selectedWeek;
    
    console.log("Body", this.data)

    // return
    this.departmentService.EditDepartment(this.data).subscribe((res) => {
      if(res.success){
        this.departmentService.showToast('success', res.message)
        this.location.back()
      }else{
        this.departmentService.showToast('error', res.message)
      }
      this.alert = res.message;

    })

  }

  cancel(){
    this.CheckArray=[]
  }

  industryListDrop : any = []
  
 subinputFocused: string = ''
 subinputFocusedmain: string = ''
  subInput(value: string) {
    if (value == 'focus') {
      this.subinputFocused = 'subinputFocused'
      this.subinputFocusedmain = 'subinputFocusedmain'
    }
    else {
      this.subinputFocused = 'generic-input-submain'
      this.subinputFocusedmain = ''
    }
  }
  timeZonesDropdown: any = []
  timeZone(value:any){
    console.log(value);
    this.data.country_name = value.name
    if(this.data.timezone != '') {
      this.data.timezone = ''
    }
    this.timeZonesDropdown = countryTimezone.getTimezones(value.name);
    console.log(this.timeZonesDropdown);    
  }

  timeZoneSelected(value:any){
    console.log(value);
    this.data.timezone = value
    if(this.data.timezone != ''){
      this.timezoneBool = true
    }else{
      this.timezoneBool = false
    }
  }

  ngOnInit(): void {
    // debugger
      
      // Call mapLoader to load the Google Maps API
      this.mapLoader();
      //---call function in service for getDepartmentId Id------
      this.departmentId=this.departmentService.getDepartmentId()

      //-------api get()calling-------------
      this.departmentService.ViewDepartmentID(this.departmentId).subscribe((res)=>{
      this.output=res.data
      console.log(this.output)

      this.data.department_id = this.output[0].department_id
      this.data.department_Foreman_id = this.output[0].department_Foreman_id
      this.data.department_Foreman_name = this.output[0].department_Foreman_name
      this.data.department_latitude = this.output[0].department_latitude
      this.data.department_longitude = this.output[0].department_longitude
      this.data.work_in_time =this.output[0].work_in_time
      this.data.work_out_time =this.output[0].work_out_time
      this.data.lunch_in_time =this.output[0].lunch_in_time
      this.data.lunch_out_time =this.output[0].lunch_out_time
      this.members = this.output[0].members
      this.data.members = this.members

      this.data.accounts_members = this.output[0]?.accounts_members
      this.data.helper_members = this.output[0]?.helper_members
      this.data.industry_types = this.output[0]?.industry_types
      this.data.warehouse_id = this.output[0]?.warehouse_id
      this.data.warehouse_name = this.output[0]?.warehouse_name
      this.data.cash_customers = this.output[0]?.cash_customers.map((customer: any) => customer.customer_id) || []
      // debugger
      if(this.output[0]?.timezone){
        this.data.timezone = this.output[0]?.timezone
        this.data.country_name = this.output[0]?.country_name
      }
       if (this.output[0]?.public_holidays) {
      this.public_holidays = this.output[0].public_holidays;
    }
    this.data.is_factory = this.output[0]?.is_factory || false;
        // debugger
      console.log(this.data.members)

      if (this.output[0]?.weekly_working_days) {
    this.selectedWeek = this.output[0].weekly_working_days;
    this.weeKDays.forEach(day => {
      day.checked = this.selectedWeek.includes(day.value);
    });
    }

      this.CheckArray = this.data.members
      this.checkArrayacc = this.data?.accounts_members
      this.checkArrayhelp = this.data?.helper_members
      this.checkArrayindustry = this.data?.industry_types



      })



    this.departmentService.ViewAllEmployee().subscribe((res) => {
      this.listEmployees = res.data


    })

    this.departmentService.industryType().subscribe({
      next : (res) => {
        this.industryListDrop = res.data
        // debugger
      },error(err) {
        alert('Industry Unknown Error')
      },
    })

    this.Warehouse_all()
    this.fetchCustomer()
    


  }

  customerDropdown:any = []

  fetchCustomer() {
    this.departmentService.customerDropdown().subscribe((res) => {
      this.customerDropdown = res.data
      console.log(this.customerDropdown)
    })
  }

  selectCustomer(event:any) {
    console.log(event);
    console.log('cash customer',this.data.cash_customers);
    
  }

mapLoaded: boolean = false;

  async mapLoader(): Promise<void> {
  try {
    await this.departmentService.loadGoogleMaps('AIzaSyBOQ9-zria589tItgtGZsbzwORm6T5_c5U');
    this.mapLoaded = true;
    // Proceed with map logic
  } catch (error) {
    console.error('Error loading Google Maps:', error);
    this.mapLoaded = false;
    // Show fallback UI
  }
}



  showCount = 3; // Number of items to initially show

    showMore() {
        this.showCount = this.checkArrayhelp.length;
    }

    showLess() {
        this.showCount = 3;
    }

    isInvalidTime: boolean = true; // For validation feedback

    validateTime(value : any): void {
      // const timePattern = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
      const timePattern = /^(\d{2}):([0-5]\d):([0-5]\d)$/;
      if(value.length == 2){
        this.estimateTime += ':'
      }else if(value.length == 5){
        this.estimateTime += ':'
        // this.validateTime(this.estimateTime)
      }else{
        this.isInvalidTime = !timePattern.test(value);
// debugger
        if (!this.isInvalidTime) {
          this.estimateTime = value; // Valid time input
        }
      }
    }

}
